module.exports = __webpack_public_path__ + "img/google-play.d56418b7.jpg";